import React from "react";
import "./PasteConfirmationModal.css";
import { ClipboardPaste } from "lucide-react";
import { t } from "../../locales/translate";

const PasteConfirmationModal = ({ isVisible, onClose, onConfirm }) => {
  if (!isVisible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-icon">
          <ClipboardPaste size={36} />
        </div>
        <h3 className="modal-title">{t("pastePlan")}</h3>
        <p className="modal-message">
          {t("pasteMonthlyPlanConfirm")}
        </p>
        <div className="modal-actions">
          <button onClick={onClose} className="modal-cancel-button" style={{width:  document.body.dir === "rtl" ? "119px" : ""}}>
            {t("cancel")}
          </button>
          <button onClick={onConfirm} className="modal-confirm-button" style={{width:  document.body.dir === "rtl" ? "123px" : ""}}>
            {t("paste")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasteConfirmationModal;
